import { render, staticRenderFns } from "./CustomerStatus.vue?vue&type=template&id=70bc04a7&"
import script from "./CustomerStatus.vue?vue&type=script&lang=js&"
export * from "./CustomerStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports